<div
  class="page-break-before spacing--margin-horizontal spacing--margin-top"
  data-test="scheme-graph"
>
  <h3 class="spacing-top">{{ 'feed-advice-detail.graph' | translate }}</h3>
  <div class="screen-only spacing--margin-top y-axes-container">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-graph.left-y-axis-label' | translate }}
      </span>
      <mat-radio-group (change)="changeSetting()" [(ngModel)]="leftYaxis">
        <mat-radio-button
          data-test="scheme-graph_left_weight-radiobutton"
          class="text--small"
          color="primary"
          value="weight"
          [disabled]="rightYaxis === 'weight'"
        >
          {{ 'scheme-table.weight' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_left_energy-radiobutton"
          class="text--small"
          color="primary"
          value="energy"
          [disabled]="rightYaxis === 'energy'"
        >
          {{ 'scheme-table.energy_value' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_left_lysine-radiobutton"
          class="text--small"
          color="primary"
          value="lysine"
          [disabled]="rightYaxis === 'lysine'"
        >
          {{ 'scheme-table.lysine' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_left_feedintake-radiobutton"
          class="text--small"
          color="primary"
          value="feedintake"
          [disabled]="rightYaxis === 'feedintake'"
        >
          {{ 'scheme-table.feed_per_day' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-graph.right-y-axis-label' | translate }}
      </span>
      <mat-radio-group (change)="changeSetting()" [(ngModel)]="rightYaxis">
        <mat-radio-button
          data-test="scheme-graph_right_weight-radiobutton"
          class="text--small"
          color="primary"
          value="weight"
          [disabled]="leftYaxis === 'weight'"
        >
          {{ 'scheme-table.weight' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_right_energy-radiobutton"
          class="text--small"
          color="primary"
          value="energy"
          [disabled]="leftYaxis === 'energy'"
        >
          {{ 'scheme-table.energy_value' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_right_lysine-radiobutton"
          class="text--small"
          color="primary"
          value="lysine"
          [disabled]="leftYaxis === 'lysine'"
        >
          {{ 'scheme-table.lysine' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="scheme-graph_right_feedintake-radiobutton"
          class="text--small"
          color="primary"
          value="feedintake"
          [disabled]="leftYaxis === 'feedintake'"
        >
          {{ 'scheme-table.feed_per_day' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="print-only spacing--margin-top">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-graph.left-y-axis-label' | translate }}
        {{ 'feed-advice-graph.' + leftYaxis | translate }}
      </span>
    </div>
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-graph.right-y-axis-label' | translate }}
        {{ 'feed-advice-graph.' + rightYaxis | translate }}
      </span>
    </div>
  </div>
  <div class="flex__child--auto chart-container">
    <agr-chart [options]="chartOptions" [dataSource]="chartSeries"></agr-chart>
  </div>
</div>
